import { BASE_URL } from "@/constants/config";
import { request } from "@/utils/request";

export const MEMBERS_ENDPOINTS = {
  list: `${BASE_URL}api/member/`,
  fileAnalysis: (memberId, campaignId) =>
    `${BASE_URL}api/member_campaign/${campaignId}/${memberId}/analysis/`,
  fileDetail: (campaignId, fileId) =>
    `${BASE_URL}api/member_campaign/${campaignId}/files/${fileId}/`,
  detail: (id) => `${BASE_URL}api/member/${id}`,
  export: `${BASE_URL}api/member/download/`,
  members_by_user: (user_email) => `${BASE_URL}api/member/member_name/${user_email}`,
  upload_member_campaign_file: (campaign_id, member_id, file_type_id) => `${BASE_URL}api/member_campaign/${campaign_id}/${member_id}/${file_type_id}`,
  delete_file: (id_file) => `${BASE_URL}api/member_campaign/delete/${id_file}`,
  download_file: (id_file) => `${BASE_URL}api/member_campaign/download/${id_file}`,
  download_quality_file: (memberId, campaignId) => `${BASE_URL}api/member_campaign/download_quality/${campaignId}/${memberId}/`,
  download_campaign_members_template: `${BASE_URL}api/member_campaign/download_template/`,
  inject_campaign_members: `${BASE_URL}api/member_campaign/upload_campaign_members/`,
  download_campaign_members: `${BASE_URL}api/member_campaign/download_campaign_members/`,
};

class Members {
  async deleteFile(id_file){
    const { data } = await request({
      url: MEMBERS_ENDPOINTS.delete_file(id_file),
      method: "DELETE",
    });
    return data;
  }

  async getFileDetail(campaignId, fileId){
    const { data } = await request({
      url: MEMBERS_ENDPOINTS.fileDetail(campaignId, fileId),
    });
    return data;
  }

  async getMembers() {
    const { data } = await request({
      url: MEMBERS_ENDPOINTS.list,
      query: { per_page: 1000 },
    });
    return data;
  }

  async getCampaignMembers(campaign_id) {
    const { data } = await request({
      url: MEMBERS_ENDPOINTS.list,
      query: { per_page: 1000, campaign_id: campaign_id},
    });
    return data;
  }

  async getMember(id) {
    const { data } = await request({
      url: MEMBERS_ENDPOINTS.detail(id),
    });
    return data;
  }

  async saveMember(memberData, id = null) {
    const { data } = await request({
      url: id ? MEMBERS_ENDPOINTS.detail(id) : MEMBERS_ENDPOINTS.list,
      method: id ? "PUT" : "POST",
      body: memberData,
    });
    return data;
  }

  async deleteMember(id) {
    const { data } = await request({
      url: MEMBERS_ENDPOINTS.detail(id),
      method: "DELETE",
    });
    return data;
  }

  async getMembersByUserEmail(user_email) {
    const { data } = await request({
      url: MEMBERS_ENDPOINTS.members_by_user(user_email),
    });
    return data;
  }
}

export const MemberService = new Members();
